import { Card, CardBody } from '@components/card/card';
import NotificationList from '@components/header/Notifications/NotificationList';
import NeatixModal from '@components/Modal/NeatixModal';
import useGetMyNotificationMessage from '@hooks/NTX/useGetMyNotificationMessage';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';

// const NotificationsList = ({ setShow }) => {
//   const { t, i18n } = useTranslation();
//   const { MyNotificationMessageList: data, loading } = useGetMyNotificationMessage();

//   // فرز البيانات وترتيبها حسب التاريخ
//   const sortedData = data
//     ?.slice()
//     ?.sort((a, b) => new Date(b.creationDate).getTime() - new Date(a.creationDate).getTime())
//     ?.slice(0, 5);

//   // دالة حساب الوقت المنقضي
//   function getTimePeriod(givenDateString) {
//     const givenDate = new Date(givenDateString);
//     const currentDate = new Date();
//     const timeDifference = currentDate.getTime() - givenDate.getTime();

//     const secondsDifference = Math.floor(timeDifference / 1000);
//     const minutesDifference = Math.floor(secondsDifference / 60);
//     const hoursDifference = Math.floor(minutesDifference / 60);
//     const daysDifference = Math.floor(hoursDifference / 24);

//     let timePeriod;
//     if (daysDifference > 0) {
//       timePeriod = daysDifference + (i18n.language === 'en' ? ' days ago' : ' يوم مضى');
//     } else if (hoursDifference > 0) {
//       timePeriod = hoursDifference + (i18n.language === 'en' ? ' hours ago' : ' ساعة مضت');
//     } else if (minutesDifference > 0) {
//       timePeriod = minutesDifference + (i18n.language === 'en' ? ' minutes ago' : ' دقيقة مضت');
//     } else {
//       timePeriod = secondsDifference + (i18n.language === 'en' ? ' seconds ago' : ' ثانية مضت');
//     }

//     return timePeriod;
//   }

//   return (
//     <>
//       <Card className='mb-4 shadow-sm h-100'>
//         <div className='card-header py-2'>
//           <div className='d-flex align-items-center'>
//             <i className='bi bi-bell-fill fs-4 text-primary me-2'></i>
//             <h5 className='flex-grow-1 m-0'>{t('NOTIFICATIONS')}</h5>
//             <span className='badge bg-primary rounded-pill'>{data?.length || 0}</span>
//           </div>
//         </div>
//         <div className='card-body p-0'>
//           {loading ? (
//             <div className='text-center p-4'>
//               <div className='spinner-grow text-success me-2'></div>
//               <div className='spinner-grow text-danger me-2'></div>
//               <div className='spinner-grow text-warning'></div>
//             </div>
//           ) : (
//             <div className='list-group list-group-flush'>
//               {sortedData && sortedData.length > 0 ? (
//                 sortedData.map(notification => (
//                   <div key={notification.id} className='list-group-item border-0 px-4 py-3'>
//                     <div className='d-flex align-items-center'>
//                       <div className='flex-shrink-0'>
//                         <div
//                           className={`${notification.icon} rounded-circle d-flex align-items-center justify-content-center text-theme`}
//                           style={{ width: '24px', height: '24px', fontSize: '16px' }}
//                         >
//                           <i className={notification.icon}></i>
//                         </div>
//                       </div>
//                       <div className='flex-grow-1 ms-3'>
//                         <div className='d-flex justify-content-between align-items-center'>
//                           <span className='fw-medium'>
//                             {!notification.isRead && (
//                               <i className='bi bi-circle-fill text-primary me-2' style={{ fontSize: '8px' }}></i>
//                             )}
//                             {i18n.language === 'en' ? notification.notificationName : notification.notificationName2}
//                           </span>
//                           <small className='text-muted'>{getTimePeriod(notification.creationDate)}</small>
//                         </div>
//                       </div>
//                     </div>
//                   </div>
//                 ))
//               ) : (
//                 <div className='text-center p-4'>
//                   {i18n.language === 'en' ? 'No notifications available' : 'لا يوجد لديك إشعارات'}
//                 </div>
//               )}
//             </div>
//           )}
//         </div>
//         <div className='card-footer'>
//           <div className='text-center'>
//             <a href='#' className='text-decoration-none small'>
//               {t('View All Notifications')} <i className='bi bi-arrow-left'></i>{' '}
//             </a>
//           </div>
//         </div>
//       </Card>
//     </>
//   );
// };
// export default NotificationsList;

const UserNotifications = () => {
  const [show, setShow] = useState(false);
  const { t, i18n } = useTranslation();
  const { MyNotificationMessageList: data, loading } = useGetMyNotificationMessage();

  // فرز البيانات حسب التاريخ
  const sortedData = data
    ?.slice()
    ?.sort((a, b) => new Date(b.creationDate).getTime() - new Date(a.creationDate).getTime())
    ?.slice(0, 8);

  // دالة حساب الوقت
  function getTimePeriod(givenDateString: string) {
    const givenDate = new Date(givenDateString);
    const currentDate = new Date();
    const timeDifference = currentDate.getTime() - givenDate.getTime();

    const secondsDifference = Math.floor(timeDifference / 1000);
    const minutesDifference = Math.floor(secondsDifference / 60);
    const hoursDifference = Math.floor(minutesDifference / 60);
    const daysDifference = Math.floor(hoursDifference / 24);

    let timePeriod;
    if (daysDifference > 0) {
      timePeriod = daysDifference + (i18n.language === 'en' ? ' days ago' : ' يوم مضى');
    } else if (hoursDifference > 0) {
      timePeriod = hoursDifference + (i18n.language === 'en' ? ' hours ago' : ' ساعة مضت');
    } else if (minutesDifference > 0) {
      timePeriod = minutesDifference + (i18n.language === 'en' ? ' minutes ago' : ' دقيقة مضت');
    } else {
      timePeriod = secondsDifference + (i18n.language === 'en' ? ' seconds ago' : ' ثانية مضت');
    }

    return timePeriod;
  }

  return (
    <>
      <Card className='mb-4 shadow-sm h-100'>
        <div className='card-header py-2'>
          <div className='d-flex align-items-center'>
            <i className='bi bi-bell-fill fs-4 text-primary me-2'></i>
            <h5 className='flex-grow-1 m-0'>{t('NOTIFICATIONS')}</h5>
            <span className='badge bg-primary rounded-pill'>{data?.length || 0}</span>
          </div>
        </div>
        <div className='card-body p-0'>
          {loading ? (
            <div className='text-center p-4'>
              <div className='spinner-grow text-success me-2'></div>
              <div className='spinner-grow text-danger me-2'></div>
              <div className='spinner-grow text-warning'></div>
            </div>
          ) : (
            <ul className='list-group list-group-flush'>
              {sortedData && sortedData.length > 0 ? (
                sortedData.map(notification => (
                  <li
                    key={notification.id}
                    className='list-group-item list-group-item-action d-flex justify-content-between align-items-start'
                    role='button' // يخليها زي الزر
                    onClick={() => console.log('فتح الإشعار:', notification.id)}
                  >
                    <div className='d-flex align-items-center'>
                      <div
                        className={`${notification.icon} rounded-circle d-flex align-items-center justify-content-center text-theme`}
                      >
                        {/* <i className={notification.icon}></i> */}
                      </div>
                      <span className='ms-3 fw-medium'>
                        {!notification.isRead && (
                          <i className='bi bi-circle-fill text-primary me-2' style={{ fontSize: '8px' }}></i>
                        )}
                        <span className='fw-bold'>
                          {i18n.language === 'en' ? notification.notificationName : notification.notificationName2}
                        </span>
                        <br />
                        <span className='text-muted opacity-75 fs-12px'>{notification.message}</span>
                      </span>
                    </div>
                    <small className='text-muted'>{getTimePeriod(notification.creationDate)}</small>
                  </li>
                ))
              ) : (
                <li className='list-group-item text-center p-4'>
                  {i18n.language === 'en' ? 'No notifications available' : 'لا يوجد لديك إشعارات'}
                </li>
              )}
            </ul>
          )}
        </div>
        <div className='card-footer'>
          <div className='text-center'>
            <a onClick={() => setShow(true)} className='text-decoration-none small'>
              {t('View All Notifications')} <i className='bi bi-arrow-left'></i>
            </a>
          </div>
        </div>
      </Card>

      <NeatixModal
        setShow={setShow}
        show={show}
        size='xl'
        // title="قائمة الإشعارات"
        showHeader={false}
        bodyClassName='p-0'
      >
        <Card>
          <CardBody>
            <NotificationList setShow={setShow} />
          </CardBody>
        </Card>
      </NeatixModal>
    </>
  );
};

export default UserNotifications;
